import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { storeInviteToken } from './lib/invite';
import { initAnalytics } from './lib/analytics';
import './styles/globals.css';
import './index.css';

// Analytics first: it records the landing URL (with any ?utm_ tags) before
// the redirect to /auth replaces it.
initAnalytics();

// Capture ?invite= before anything (including a Cognito redirect) can wipe the query string.
const inviteParam = new URLSearchParams(window.location.search).get('invite');
if (inviteParam) storeInviteToken(inviteParam);

Sentry.init({
  dsn: 'https://d23353dfd32c668a4b7404c8cb37aee3@o4511422730600448.ingest.de.sentry.io/4511422743773264',
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: false }),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: false,
});

// When a new service worker takes control, reload so users get the latest code.
// The `refreshing` flag prevents a reload loop if controllerchange fires twice.
if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p style={{ padding: 24, fontFamily: 'sans-serif' }}>Something went wrong. Please refresh.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
